module.exports = __webpack_public_path__ + "static/media/clinician-watchman-device-3582w.c331093e.webp";